<bp-svg-icon *ngIf="msg" name="hint" class="bp-icon-{{ size }}" [bpTooltip]="msg"> </bp-svg-icon>
